import type { IGame } from '../../types';
import { h, Fragment } from 'preact';
import { memo, useCallback, PropsWithChildren } from 'preact/compat';
import { ExposeElement } from '@/components/expose-elem';
import { Grid, Row, Col } from '@/components/grid';

interface IGameListProps extends PropsWithChildren {
  list: IGame[];
  layerName: string;
  routeMode: 'REDIRECT' | 'NAVIGATE';
  onGameClick?: (game: IGame) => void;
  orientation: 'portrait' | 'landscape';
}

interface IGameDetailProps {
  game: IGame;
  layerName: string;
  orientation: 'portrait' | 'landscape';
  routeMode: 'REDIRECT' | 'NAVIGATE';
  onGameClick?: (game: IGame) => void;
}

const GameDetail = ({ game, layerName, orientation, routeMode, onGameClick }: IGameDetailProps) => {
  const handleGameClick = useCallback(
    (e: Event) => {
      e.preventDefault();
      onGameClick?.(game);
    },
    [onGameClick, game]
  );

  const handleExposure = useCallback(() => {
    // eventTracker.track({
    //   name: "GamesItem",
    //   type: EventType.Expose,
    //   extra: {
    //     gameId: game.gameId,
    //     name: game.name,
    //     layerName,
    //   },
    // });
    //TODO：曝光游戏
  }, [game, layerName]);

  // 在横屏模式下使用更小的span，确保一行能展示更多项目
  const colSpan = orientation === 'landscape' ? 4 : 8;

  return (
    <Col
      span={colSpan}
      className="relative px-[4px] box-border mb-[8px]"
      key={game.gameId}
      style={{
        marginBottom: orientation === 'landscape' ? '8px' : '16px',
        paddingLeft: '8px',
        paddingRight: '8px'
      }}
      onClick={handleGameClick}
      role="button"
      tabIndex={0}
    >
      <div className="relative w-full mb-[2px] ion-no-margin">
        <ExposeElement
          src={game.logo ?? game.cover ?? ''}
          className="w-full h-full absolute top-0 left-0 aspect-square rounded-[8px] object-cover"
          style={{ display: 'block', objectFit: 'cover' }}
          handleExposure={handleExposure}
        />
      </div>
      <div
        className="block text-white max-w-full text-[15px] leading-[1.2] overflow-hidden whitespace-nowrap text-ellipsis font-normal break-words"
        style={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          wordBreak: 'break-word',
          color: 'white',
          maxWidth: '100%',
          fontSize: orientation === 'landscape' ? '13px' : '15px',
          lineHeight: 1.2,
          fontWeight: 'normal',
          marginTop: '6px',
          fontFamily: 'PingFangSC-Regular'
        }}
      >
        {game.name}
      </div>
    </Col>
  );
};

const GamesGridInner = ({
  list,
  routeMode,
  layerName,
  onGameClick,
  orientation,
  ...restProps
}: IGameListProps) => {
  return (
    <Grid
      className="w-full mx-auto flex-grow overflow-y-auto"
      style={{
        maxWidth: orientation === 'landscape' ? '100%' : '440px',
        minHeight: '1px'
      }}
    >
      <Row
        gutter={8}
        style={{
          display: 'flex',
          flexWrap: orientation === 'landscape' ? 'nowrap' : 'wrap',
          overflowX: orientation === 'landscape' ? 'auto' : 'visible',
          paddingBottom: orientation === 'landscape' ? '10px' : '0',
          justifyContent: orientation === 'landscape' ? 'flex-start' : 'center'
        }}
      >
        {list?.map((game) => (
          <GameDetail
            orientation={orientation}
            game={game}
            key={game.gameId}
            routeMode={routeMode}
            layerName={layerName}
            onGameClick={onGameClick}
          />
        ))}
      </Row>
    </Grid>
  );
};

export const GamesGrid = memo(GamesGridInner);
